import { render, staticRenderFns } from "./FormActions.vue?vue&type=template&id=55666dcf"
import script from "./FormActions.vue?vue&type=script&lang=ts"
export * from "./FormActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports